import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Logo } from "../components/Logo";

interface Coupon {
  site: string;
  code: string;
  link: string;
}

interface ResultItem {
  title: string;
  price: string;
  link: string;
  coupon?: Coupon;
}

export default function SmartSearchPage() {
  const [query, setQuery] = useState("");
  const [results, setResults] = useState<ResultItem[] | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSearch = async () => {
    if (!query.trim()) return;
    setLoading(true);
    setError(null);
    setResults(null);

    try {
      const response = await fetch(
        "https://asmiybmtgunpbxbsrlkt.supabase.co/functions/v1/bright-handler",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // 🛑 ייתכן שזה גורם לבעיה בזמן build – נחליף בגישה בטוחה
            Authorization: `Bearer ${import.meta.env.VITE_SUPABASE_ANON_KEY || ""}`,
          },
          body: JSON.stringify({ query: query.trim() }),
        }
      );

      if (!response.ok) {
        throw new Error("שגיאה בקבלת תשובה מהשרת");
      }

      const data = await response.json();
      console.log("data:", data);

      if (!Array.isArray(data)) {
        throw new Error("מבנה תגובה לא תקין");
      }

      setResults(data);
    } catch (err: any) {
      setError(err.message || "שגיאה כללית");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-purple-50 flex flex-col justify-center items-center px-4">
      <div className="max-w-3xl w-full text-right">
        <Logo />
        <h1 className="text-3xl font-bold text-gray-800 mt-6 mb-4">רעיונות חכמים למתנות</h1>
        <p className="text-gray-600 text-lg mb-8">
          הקלד מה אתה מחפש – ונחזיר לך הצעות בזמן אמת
        </p>

        <input
          type="text"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="לדוגמה: מתנה לאמא שאוהבת גינון עד 200 ש״ח"
          className="w-full p-4 rounded-lg border border-gray-300 mb-4 shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400"
          dir="rtl"
        />
        <button
          onClick={handleSearch}
          className="w-full bg-purple-600 text-white py-3 rounded-lg hover:bg-purple-700 transition"
          disabled={loading}
        >
          {loading ? "טוען..." : "מצא מתנות"}
        </button>

        {error && <div className="mt-4 text-red-600">{error}</div>}

        {results && (
          <div className="mt-8 space-y-6">
            {results.map((r, i) => (
              <div
                key={i}
                className="relative border rounded-lg p-4 shadow bg-white flex flex-col md:flex-row justify-between items-start md:items-center"
              >
                <div>
                  <div className="font-bold text-lg text-gray-800 mb-1">{r.title}</div>
                  <div className="text-green-600 text-md">₪{r.price.replace(/₪/g, "")}</div>
                  <a
                    href={r.link}
                    target="_blank"
                    rel="noreferrer"
                    className="text-blue-600 underline mt-1 inline-block"
                  >
                    מעבר למוצר
                  </a>
                </div>
                {r.coupon && (
                  <div className="absolute left-4 top-4 bg-yellow-100 border border-yellow-300 text-yellow-800 px-3 py-1 rounded text-sm shadow">
                    קופון: <span className="font-bold">{r.coupon.code}</span>
                  </div>
                )}
              </div>
            ))}

            <div className="text-center mt-6">
              <a
                href="https://shopygood.net/collections/all"
                target="_blank"
                className="text-purple-700 hover:underline text-md"
              >
                🎁 קופונים עד 90% למציאת מתנות הכנס
              </a>
            </div>
          </div>
        )}

        <div className="text-center mt-6">
          <Link to="/compare" className="inline-block text-purple-600 hover:underline">
            ← חזרה לעמוד ההשוואות
          </Link>
        </div>
      </div>
    </div>
  );
}
